import { render, staticRenderFns } from "./PasswordEmail.vue?vue&type=template&id=0104c593&scoped=true&"
import script from "./PasswordEmail.vue?vue&type=script&lang=js&"
export * from "./PasswordEmail.vue?vue&type=script&lang=js&"
import style0 from "./PasswordEmail.vue?vue&type=style&index=0&id=0104c593&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0104c593",
  null
  
)

export default component.exports